/**
 * @param html
 * @returns {string}
 */
export const escapeHtml = (html) => {
	return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

/**
 * 문자열 내 url 패턴을 자동으로 a 태그로 교체한다.
 * @param {string} str
 * @returns {string}
 */
export const activateUrlAutomatically = (str) => {
	return str.replace(
		/(https?:)?(\/\/)?(((([a-z가-힣\d](-*[a-z가-힣\d])*)\.)+[a-z가-힣]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z가-힣\d%_.~+]*)*(\?[;&a-z가-힣\d%_.~+=-]*)?(#[-a-z가-힣\d_]*)?)/gi,
		'<a href="$1//$3" target="_blank" rel="noopener">$&</a>'
	);
};

/**
 * 이미지 썸네일 URL을 생성한다.
 * @param {string} url
 * @param {number} width
 * @param {number} height
 * @param {string} cropOption
 * @returns {string}
 */
export const getThumbnailUrl = (url, width, height, cropOption) => {
	const host = url.match(/sandbox\.kakaocdn\.net/)
		? 'img1-sandbox.kakaocdn.net'
		: 'img1.daumcdn.net';

	return `//${host}/thumb/${cropOption}${width}x${height}/?fname=${encodeURIComponent(url)}`;
};

export const login = (url) => {
	const returnUrl = url || document.URL;
	window.location.href = `${CAFEAPP.LOGIN_URL}/accounts/loginform.do?mobilefull=1&url=${encodeURIComponent(returnUrl)}`;
};

/**
 * 비로그인 처리용 HOF
 * @param {function} cb
 * @returns {Promise<*>}
 */
export const loginIfPermissionDenied = async (cb) => {
	try {
		return await cb();
	} catch (e) {
		if (e.response?.status === 401) {
			login();
		} else {
			throw e;
		}
	}
};

const HTTP_PREFIX = "http://"
const HTTPS_PREFIX = "https://"

/**
 * 이미지 주소가 t1.daumcdn.net, t1-beta.daumcdn.net, t1.kakaocdn.net, t1-beta.kakaocdn.net, t1-sandbox.kakaocdn.net 이 아닐 시
 * http 로 시작하는 지 확인하고, http로 시작하지 않는 다면 https:// prefix 로 설정하여 javascript 스킴이 불가능하도록 한다.
 * @param url
 */
export const escapeScheduleImageThumbUrl = (url) => {
	if (url.match(/^(http|https):\/\/(t1|t1-beta|t1-sandbox)\.(daum|kakao)cdn\.net\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/)) {
		return url;
	}

	if (url.startsWith(HTTP_PREFIX) || url.startsWith(HTTPS_PREFIX)) {
		return url;
	}

	return HTTPS_PREFIX + url;
}

/**
 * url 에 스크립트가 실행 될 수 있는 경우 HTTPS_PREFIX(https://) 를 추가해 스크립트가 실행되지 않도록 한다.
 * ex) javascript:alert(`xss`)
 * @param url
 */
export const prependHttpPrefix = (url) => {
	if (url.startsWith(HTTP_PREFIX) || url.startsWith(HTTPS_PREFIX)) {
		return url
	}

	return HTTPS_PREFIX + url
}
